export var CollectionType;
(function (CollectionType) {
    /** User-created collection. */
    CollectionType["NATIVE"] = "NATIVE";
    /** [Collection](https://support.wix.com/en/article/velo-working-with-wix-app-collections-and-code#what-are-wix-app-collections) created by a Wix app when it is installed. This type of collection can be modified dynamically by that app (for example, Wix Forms). */
    CollectionType["WIX_APP"] = "WIX_APP";
    /** Collection created by a Wix Blocks app. */
    CollectionType["BLOCKS_APP"] = "BLOCKS_APP";
    /** Collection located in externally connected storage. */
    CollectionType["EXTERNAL"] = "EXTERNAL";
})(CollectionType || (CollectionType = {}));
export var Direction;
(function (Direction) {
    Direction["ASC"] = "ASC";
    Direction["DESC"] = "DESC";
})(Direction || (Direction = {}));
export var DataOperation;
(function (DataOperation) {
    DataOperation["AGGREGATE"] = "AGGREGATE";
    DataOperation["BULK_INSERT"] = "BULK_INSERT";
    DataOperation["BULK_REMOVE"] = "BULK_REMOVE";
    DataOperation["BULK_SAVE"] = "BULK_SAVE";
    DataOperation["BULK_UPDATE"] = "BULK_UPDATE";
    DataOperation["COUNT"] = "COUNT";
    DataOperation["DISTINCT"] = "DISTINCT";
    DataOperation["FIND"] = "FIND";
    DataOperation["GET"] = "GET";
    DataOperation["INSERT"] = "INSERT";
    DataOperation["INSERT_REFERENCE"] = "INSERT_REFERENCE";
    DataOperation["IS_REFERENCED"] = "IS_REFERENCED";
    DataOperation["QUERY_REFERENCED"] = "QUERY_REFERENCED";
    DataOperation["REMOVE"] = "REMOVE";
    DataOperation["REMOVE_REFERENCE"] = "REMOVE_REFERENCE";
    DataOperation["REPLACE_REFERENCES"] = "REPLACE_REFERENCES";
    DataOperation["SAVE"] = "SAVE";
    DataOperation["TRUNCATE"] = "TRUNCATE";
    DataOperation["UPDATE"] = "UPDATE";
    DataOperation["PATCH"] = "PATCH";
    DataOperation["BULK_PATCH"] = "BULK_PATCH";
})(DataOperation || (DataOperation = {}));
export var CollectionOperation;
(function (CollectionOperation) {
    /** Allows updating the collection's structure, for example adding, updating, or deleting fields. If not included, the collection's structure can't be changed. */
    CollectionOperation["UPDATE"] = "UPDATE";
    /** Allows deleting the entire collection. If not included, the collection can't be deleted. */
    CollectionOperation["REMOVE"] = "REMOVE";
})(CollectionOperation || (CollectionOperation = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    /** Plain-text string. */
    FieldType["TEXT"] = "TEXT";
    /** Number. */
    FieldType["NUMBER"] = "NUMBER";
    /** Date string in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format: `YYYY-MM-DD`. */
    FieldType["DATE"] = "DATE";
    /** [JavaScript Date object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/data-types-in-wix-data)) or an object in the following format: `"someFieldKey": { "$date": "YYYY-MM-DDTHH:mm:ss.sssZ"}` ([REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data)). */
    FieldType["DATETIME"] = "DATETIME";
    /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
    FieldType["IMAGE"] = "IMAGE";
    /** Boolean `true` or `false` value. */
    FieldType["BOOLEAN"] = "BOOLEAN";
    /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
    FieldType["DOCUMENT"] = "DOCUMENT";
    /** URL in one of the following formats: `http://`, `https://`, `ftp://`, `mailto:`, `sms:`, `tel:`. */
    FieldType["URL"] = "URL";
    /** [Rich-text](https://dev.wix.com/docs/rest/articles/getting-started/rich-text) string that may contain a subset of HTML tags. */
    FieldType["RICH_TEXT"] = "RICH_TEXT";
    /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
    FieldType["VIDEO"] = "VIDEO";
    /** Any field type. */
    FieldType["ANY"] = "ANY";
    /** Array of strings. */
    FieldType["ARRAY_STRING"] = "ARRAY_STRING";
    /** Array of documents: web or [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URLs. */
    FieldType["ARRAY_DOCUMENT"] = "ARRAY_DOCUMENT";
    /** Web URL or a [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URL. */
    FieldType["AUDIO"] = "AUDIO";
    /** Time string in `hh:mm:ss.SSS` format. */
    FieldType["TIME"] = "TIME";
    /** Language codes in [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes) format. These may include country codes in [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#officially_assigned_code_elements) format. */
    FieldType["LANGUAGE"] = "LANGUAGE";
    /** [Rich content](https://dev.wix.com/docs/ricos/getting-started/introduction). */
    FieldType["RICH_CONTENT"] = "RICH_CONTENT";
    /** Array of web or [Media Manager](https://dev.wix.com/docs/rest/assets/media/media-manager/introduction) URLs. */
    FieldType["MEDIA_GALLERY"] = "MEDIA_GALLERY";
    /** Physical address object ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/data-types-in-wix-data#address-object) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-types-in-wix-data#address-object)). */
    FieldType["ADDRESS"] = "ADDRESS";
    /** [Dynamic page link](https://support.wix.com/en/article/cms-linking-to-dynamic-pages). */
    FieldType["PAGE_LINK"] = "PAGE_LINK";
    /**
     * Reference to another item in another collection. See Query Referenced Data Items ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/items/query-referenced) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/query-referenced-data-items)) to learn about item references.
     *
     * If you select this type, then you must pass the `referencedCollectionId` field as well.
     */
    FieldType["REFERENCE"] = "REFERENCE";
    /** References to multiple items in another collection. See Query Referenced Data Items ([SDK](https://dev.wix.com/docs/sdk/backend-modules/data/items/query-referenced) | [REST](https://dev.wix.com/docs/rest/business-solutions/cms/data-items/query-referenced-data-items)) to learn about item references. */
    FieldType["MULTI_REFERENCE"] = "MULTI_REFERENCE";
    /** JSON object. */
    FieldType["OBJECT"] = "OBJECT";
    /** Array. */
    FieldType["ARRAY"] = "ARRAY";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_TIME"] = "LEGACY_TIME";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_BOOK"] = "LEGACY_BOOK";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_EXTERNAL_URL"] = "LEGACY_EXTERNAL_URL";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_BROKEN_REFERENCE"] = "LEGACY_BROKEN_REFERENCE";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_IMAGE"] = "LEGACY_IMAGE";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_COLOR"] = "LEGACY_COLOR";
    /** Deprecated type that might appear in legacy collections. */
    FieldType["LEGACY_EXTERNAL_VIDEO"] = "LEGACY_EXTERNAL_VIDEO";
    /** SLUG type used for dynamic page URLs. */
    FieldType["SLUG"] = "SLUG";
})(FieldType || (FieldType = {}));
export var QueryOperator;
(function (QueryOperator) {
    QueryOperator["EQ"] = "EQ";
    QueryOperator["LT"] = "LT";
    QueryOperator["GT"] = "GT";
    QueryOperator["NE"] = "NE";
    QueryOperator["LTE"] = "LTE";
    QueryOperator["GTE"] = "GTE";
    QueryOperator["STARTS_WITH"] = "STARTS_WITH";
    QueryOperator["ENDS_WITH"] = "ENDS_WITH";
    QueryOperator["CONTAINS"] = "CONTAINS";
    QueryOperator["HAS_SOME"] = "HAS_SOME";
    QueryOperator["HAS_ALL"] = "HAS_ALL";
    QueryOperator["EXISTS"] = "EXISTS";
    QueryOperator["URLIZED"] = "URLIZED";
})(QueryOperator || (QueryOperator = {}));
export var FieldPluginType;
(function (FieldPluginType) {
    /** Uknown plugin type. */
    FieldPluginType["UNKNOWN"] = "UNKNOWN";
    /** CMS-related field attributes */
    FieldPluginType["CMS"] = "CMS";
})(FieldPluginType || (FieldPluginType = {}));
export var Role;
(function (Role) {
    /** Unknown role. */
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Site administrator. */
    Role["ADMIN"] = "ADMIN";
    /** Signed-in user who added content to this collection. */
    Role["SITE_MEMBER_AUTHOR"] = "SITE_MEMBER_AUTHOR";
    /** Any signed-in user. */
    Role["SITE_MEMBER"] = "SITE_MEMBER";
    /** Any site visitor. */
    Role["ANYONE"] = "ANYONE";
})(Role || (Role = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_PUBLISH_PLUGIN_STATUS"] = "UNKNOWN_PUBLISH_PLUGIN_STATUS";
    Status["PUBLISHED"] = "PUBLISHED";
    Status["DRAFT"] = "DRAFT";
})(Status || (Status = {}));
export var Format;
(function (Format) {
    Format["UNKNOWN_URLIZED_PLUGIN_FORMAT"] = "UNKNOWN_URLIZED_PLUGIN_FORMAT";
    /** Letters are converted to lower case and spaces are replaced with dashes before generating the encoded URL. */
    Format["ORIGINAL"] = "ORIGINAL";
    /** No changes are made before generating the encoded URL. */
    Format["PLAIN"] = "PLAIN";
})(Format || (Format = {}));
export var Type;
(function (Type) {
    /** Unknown plugin type. */
    Type["UNKNOWN_PLUGIN_TYPE"] = "UNKNOWN_PLUGIN_TYPE";
    /** Allows items to be marked as either draft or published. For each item you can set a publishing time when the item will become visible to site visitors. */
    Type["PUBLISH"] = "PUBLISH";
    /** Ensures the collection can have one item at most. Can only be applied to a new collection. */
    Type["SINGLE_ITEM"] = "SINGLE_ITEM";
    /** Generates item URLs for collections used by dynamic pages. */
    Type["URLIZED"] = "URLIZED";
    /** Deprecated. Will be removed in the future. */
    Type["GRIDAPPLESS"] = "GRIDAPPLESS";
    /** Indicates that the collection is translatable. This allows you to manage translation for selected fields using [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual). */
    Type["MULTILINGUAL"] = "MULTILINGUAL";
    /** Indicates that collection is shared with current site. */
    Type["SHARED"] = "SHARED";
    /** Indicates that page link fields are persisted and can be updated. */
    Type["EDITABLE_PAGE_LINK"] = "EDITABLE_PAGE_LINK";
    /** CMS-specific collection properties. */
    Type["CMS"] = "CMS";
    /** Indicates that the collection is used as a [Wix Catalog](https://dev.wix.com/docs/rest/business-solutions/e-commerce/catalogs/catalog-service-plugin/introduction) app. This plugin is used to manage product data and is required for collections that are part of a catalog. */
    Type["CATALOG"] = "CATALOG";
})(Type || (Type = {}));
export var PagingMode;
(function (PagingMode) {
    /** Offset-based paging. */
    PagingMode["OFFSET"] = "OFFSET";
    /** Cursor-based paging. */
    PagingMode["CURSOR"] = "CURSOR";
})(PagingMode || (PagingMode = {}));
/**
 * Describes who can perform certain action.
 * Each level includes all levels below it (except UNDEFINED).
 */
export var AccessLevel;
(function (AccessLevel) {
    /** Not set. */
    AccessLevel["UNDEFINED"] = "UNDEFINED";
    /** Any subject, including visitors. */
    AccessLevel["ANYONE"] = "ANYONE";
    /** Any signed-in user (both site members and collaborators). */
    AccessLevel["SITE_MEMBER"] = "SITE_MEMBER";
    /** Any signed-in user, but site members only have access to own items. */
    AccessLevel["SITE_MEMBER_AUTHOR"] = "SITE_MEMBER_AUTHOR";
    /** Site collaborator that has a role with CMS Access permission. */
    AccessLevel["CMS_EDITOR"] = "CMS_EDITOR";
    /** CMS administrators and users or roles granted with special access. */
    AccessLevel["PRIVILEGED"] = "PRIVILEGED";
})(AccessLevel || (AccessLevel = {}));
export var Segment;
(function (Segment) {
    Segment["UNKNOWN_SEGMENT"] = "UNKNOWN_SEGMENT";
    Segment["PUBLIC"] = "PUBLIC";
    Segment["DEV"] = "DEV";
})(Segment || (Segment = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var TenantMode;
(function (TenantMode) {
    /** MetaSite */
    TenantMode["META_SITE"] = "META_SITE";
    /** Account */
    TenantMode["ACCOUNT"] = "ACCOUNT";
    /** App */
    TenantMode["APP"] = "APP";
})(TenantMode || (TenantMode = {}));
/**
 * Order determines how values are ordered in the index. This is important when
 * ordering and/or range querying by indexed fields.
 */
export var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
export var IndexStatus;
(function (IndexStatus) {
    /** Place holder. Never returned by the service. */
    IndexStatus["UNKNOWN"] = "UNKNOWN";
    /** Index creation is in progress. */
    IndexStatus["BUILDING"] = "BUILDING";
    /** Index has been successfully created and can be used in queries. */
    IndexStatus["ACTIVE"] = "ACTIVE";
    /** Index is in the process of being dropped. */
    IndexStatus["DROPPING"] = "DROPPING";
    /** Index has been dropped successfully. */
    IndexStatus["DROPPED"] = "DROPPED";
    /** Index creation has failed. */
    IndexStatus["FAILED"] = "FAILED";
    /** Index contains incorrectly indexed data. */
    IndexStatus["INVALID"] = "INVALID";
})(IndexStatus || (IndexStatus = {}));
export var IndexSource;
(function (IndexSource) {
    /** Place holder. Never returned by the service. */
    IndexSource["UNKNOWN_INDEX_SOURCE"] = "UNKNOWN_INDEX_SOURCE";
    /**
     * Automatically created by Wix for all collections.
     *
     * System indexes are created for essential attributes, such as ID and creation date.
     * You can't delete them and they don't count towards the index limit.
     */
    IndexSource["SYSTEM"] = "SYSTEM";
    /** Created by a Wix user via the API or in the dashboard. */
    IndexSource["USER"] = "USER";
    /**
     * Created automatically by Wix based on a Wix user's queries.
     *
     * For large collections, Wix identifies slow-running queries and creates indexes automatically to improve performance.
     * These indexes don't count towards the index limit. They're created dynamically, and may be deleted if they no longer fit
     * the system's parameters. To keep an automatic index permanently, manually create an identical `USER` index.
     */
    IndexSource["AUTO"] = "AUTO";
})(IndexSource || (IndexSource = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map